import { STATUS_ICON_LOADING } from '@/common/utils/statuses';
import createCommonModule from '@/common/store/modules/common';
import { TaskState } from '@schema';
import { TaskName } from '@/common/constants/taskNames.constants';
import { DEFAULT_REQUEST_VIEW } from '@/common/store/modules/common/common.constants';
import getClusterId from '@/common/store/pinia/storageCluster/getClusterId';
import { groupBy } from 'lodash-es';

function resource({ rootState }, targetGroupId) {
  return getClusterId()
    .then(clusterId => (`/api/v2/${clusterId}/iscsi-alua/target-groups/${targetGroupId || rootState.routes.params.targetGroupId}/volumes`));
}

function plural(data) {
  return data.map(lun => ({
    ...lun,
    volumeName: lun.name,
    name: lun.lun?.id,
    isDeletable: lun.lun?.id !== 0 || (lun.lun?.id === 0 && data.length === 1),
    statusIcon: (lun.tasks && lun.tasks.length) ? STATUS_ICON_LOADING : false
  }));
}

export default createCommonModule({
  resource,
  plural,
  Model: Object,
  actions: {
    FETCH_ITEMS(store, payload) {
      const { commit, dispatch } = store;
      const { options, view = DEFAULT_REQUEST_VIEW, targetGroupId, ...params } = payload;

      commit('ADD_REQUEST_VIEW', view);
      commit('LOADING', view);
      commit('SET_MARKER', { view });

      return resource(store, targetGroupId)
      .then(resourceStr => this.$api.get(resourceStr, params, { ...options }))
      .then((res) => {
        dispatch('SET_ITEMS', { data: res.data, view, merge: options?.merge ?? true });
        commit('SET_REQUEST_PARAMS', { requestParams: params, view });

        return res;
      })
      .catch((error) => {
        commit('SET_ERRORS', error);

        throw error;
      })
      .finally(() => {
        commit('LOADED', view);
      });
    },
    ATTACH_VOLUME(store, params) {
      return resource(store, params.targetGroupId)
        .then(resourceStr => this.$api.post(resourceStr, {
          volume_id: params.volume_id,
          lun_id: params.lun
        }));
    },
    async ATTACH_VOLUMES({ dispatch }, payload) {
      const { zeroLun = [], volumes = [] } = groupBy(payload.volumes, volume => volume.lun === 0 ? 'zeroLun' : 'volumes');

      const attachVolumes = () => Promise.all(volumes.map(volume => dispatch('ATTACH_VOLUME', {
        targetGroupId: payload.targetGroupId,
        ...volume
      })));
      const attachZeroLun = () => dispatch('ATTACH_VOLUME', {
        targetGroupId: payload.targetGroupId,
        ...zeroLun[0]
      });

      if (zeroLun.length) {
        await attachZeroLun();
      }
      if (volumes.length) {
        await attachVolumes();
      }

      return Promise.resolve();
    },
    DELETE(store, { targetGroupId, id }) {
      return resource(store, targetGroupId).then(resourceStr => this.$api.delete(`${resourceStr}/${id}`));
    },
    async DELETE_ITEMS({ dispatch }, items) {
      const { zeroLun = [], luns = [] } = groupBy(items, item => item.lun.id === 0 ? 'zeroLun' : 'luns');

      const deleteLuns = () => Promise.all(luns.map(lun => dispatch('DELETE', lun)));
      const deleteZeroLun = () => dispatch('DELETE', zeroLun[0]);

      if (luns.length) {
        await deleteLuns();
      }
      if (zeroLun.length) {
        await deleteZeroLun();
      }

      return Promise.resolve();
    },
    socket_tasks({ dispatch }, { name, state, result }) {
      if (name === TaskName.BLOCK_STORAGE_TARGET_GROUP_CHANGE && state === TaskState.SUCCESS) {
        dispatch('FETCH_ITEMS', { targetGroupId: result.id });
      }
      if (name === TaskName.BLOCK_STORAGE_VOLUME_CHANGE && state === TaskState.SUCCESS) {
        dispatch('FETCH_ITEMS', { targetGroupId: result.grp_id });
      }
    }
  }
});
